import { styled } from "@mui/material/styles";

const ContactMain = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },

  [theme.breakpoints.up("md")]: {
    width: "100%",
  },

  [theme.breakpoints.up("lg")]: {
    width: "100%",
  },
}));
const ContactContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },

  [theme.breakpoints.up("md")]: {
    width: "100%",
  },

  [theme.breakpoints.up("lg")]: {
    width: "70%",
  },
  ".loadMore_main": {
    width: "100%",
    margin: "auto",
    marginBottom: "5px",
  },
}));

export { ContactMain, ContactContainer };
